import useLanguageProvider from "components/LanguageProvider/hooks/useLanguageProvider";
const TranslatableProps = ["value", "defaultValue", "defaultOption", "loadingMessage", "label", "placeholder", "subtext", "error"];
const FormInputTranslator = (props) => {
    const { translate: t } = useLanguageProvider();
    const translatedProps = { ...props };
    TranslatableProps.forEach((key) => {
        var _a, _b, _c, _d;
        const value = props[key];
        if (typeof value === "string") {
            translatedProps[key] = t(value);
        }
        if (key === "defaultOption") {
            translatedProps.defaultOption = {
                label: t((_b = (_a = props[key]) === null || _a === void 0 ? void 0 : _a.label) !== null && _b !== void 0 ? _b : ""),
                value: t((_d = (_c = props[key]) === null || _c === void 0 ? void 0 : _c.value) !== null && _d !== void 0 ? _d : ""),
            };
        }
        if (key === "error" && value) {
            translatedProps.error = {
                message: t(props[key].message),
            };
        }
    });
    return translatedProps;
};
export default FormInputTranslator;
